import { useState } from 'react';
import storage from 'utils/sessionStorage';
export type ViewMode = 'list' | 'grid';

const useViewMode = () => {
  const [mode, setMode] = useState<ViewMode>(() => (storage.modeViewMedia.get() as ViewMode) || 'list');

  const setViewMode = (mode: ViewMode) => {
    storage.modeViewMedia.set(mode);
    setMode(mode);
  };

  return { mode, setViewMode };
};

export default useViewMode;
